/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Ua_TitleInputs */

const en_bot_ua_title = /** @type {(inputs: Bot_Ua_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to recognise BystepBot`)
};

const id_bot_ua_title = /** @type {(inputs: Bot_Ua_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara mengenali BystepBot`)
};

/**
* | output |
* | --- |
* | "How to recognise BystepBot" |
*
* @param {Bot_Ua_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_ua_title = /** @type {((inputs?: Bot_Ua_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Ua_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_ua_title(inputs)
	return en_bot_ua_title(inputs)
});